import clsx from "clsx";

type TPaginationItem = {

    value:number;
    currentPage:number;
    disabled:boolean;
    onClick:(event:any, value:number) => void;

    className?:string 
    activeClassName?:string;

}

const PaginationItem = ( props:TPaginationItem ) => {

    if (props.value === props.currentPage) {
        return (
            <li key={props.value}><span className={clsx(props.className, props.activeClassName)}>{props.value}</span></li>
        );
    }

    return (
        <li>
            <a onClick={event => { if(!props.disabled) props.onClick(event, props.value); }} className={props.className} key={props.value}>{props.value}</a>
        </li>
    );

};


export default PaginationItem;
